var map = {
	"./miaosha_order.vue": [
		"DjBI",
		1
	],
	"./sale_orders.vue": [
		"6x9C",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "jQWn";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views/admin/pages lazy ^\.\/.*\.vue$
// module id = jQWn
// module chunks = 3